var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('block',{attrs:{"template":_vm.appData[_vm.$i18n.culture].Layout.Parts.logintemplate.Id,"block":_vm.appData[_vm.$i18n.culture].Layout}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }